export default "__VITE_ASSET__BrBKXHE8__"